import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createSlots as _createSlots, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { CardTitle } from '@/components/ui/card';
    import { columns } from '@/tables/columns/power-bi-setup';
    import { computed } from 'vue';
    import { Head } from '@inertiajs/vue3';
    import { usePage } from '@inertiajs/vue3';
    import { usePermissions } from '@/composables/usePermissions';
    import { useQuery } from '@tanstack/vue-query';
    import AppLayout from '@/layouts/AppLayout.vue';
    import axios from 'axios';
    import CreateBIReport from '@/components/power-bi/CreateBIReport.vue';
    import DataTable from '@/components/datatable/DataTable.vue';
    import DataTableToolbarActions from '@/components/datatable/DataTableToolbarActions.vue';
    import PageCard from '@/components/PageCard.vue';
    import Permission from '@/enums/Permission';
    import QueryKey from '@/enums/QueryKey';
    import type { SharedData, BreadcrumbItem, User } from '@/types';
    import UploadBiReport from '@/components/power-bi/UploadBiReport.vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'Setup',
  setup(__props) {

    const { hasPermission } = usePermissions();
    const page = usePage<SharedData>();
    const selectedCompanyId = computed(() => page.props.auth.user.selected_company_id);

    const breadcrumbs: BreadcrumbItem[] = [
        {
            title: 'menu.power_bi',
        },
        {
            title: 'menu.power_bi_mapping',
            href: route('v2.powerbi.setup.index'),
        },
    ];

    const { isPending, isFetching, isError, data, error, refetch } = useQuery({
        queryKey: [QueryKey.POWER_BI, selectedCompanyId],
        queryFn: getPowerBiSetup,
    });

    async function getPowerBiSetup() {
        const { data } = await axios.get(route('v2.powerbi.setup.table'));
        return data.data;
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Head), {
      title: _ctx.$t('menu.power_bi_mapping')
    }, null, 8, ["title"]),
    _createVNode(AppLayout, { breadcrumbs: breadcrumbs }, {
      default: _withCtx(() => [
        _createVNode(PageCard, null, {
          default: _withCtx(() => [
            _createVNode(DataTable, {
              "table-key": _unref(QueryKey).POWER_BI,
              columns: _unref(columns),
              data: _unref(data),
              loading: _unref(isPending)
            }, _createSlots({
              title: _withCtx(() => [
                _createVNode(_unref(CardTitle), null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('menu.power_bi_settings')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 2
            }, [
              (_unref(hasPermission)(_unref(Permission).POWERBI_SETUP_CREATE))
                ? {
                    name: "actions",
                    fn: _withCtx(() => [
                      _createVNode(DataTableToolbarActions, { name: "power-bi-setup" }, {
                        default: _withCtx(() => [
                          (_unref(hasPermission)(_unref(Permission).POWERBI_SETUP_CREATE))
                            ? (_openBlock(), _createBlock(CreateBIReport, { key: 0 }))
                            : _createCommentVNode("", true),
                          (_unref(hasPermission)(_unref(Permission).POWERBI_SETUP_CREATE))
                            ? (_openBlock(), _createBlock(UploadBiReport, { key: 1 }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    key: "0"
                  }
                : undefined
            ]), 1032, ["table-key", "columns", "data", "loading"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})